import { Box } from "@mui/material";
import Flex from "../../../../../../../../components/Flex";
import Text from "../../../../../../../../components/Text";
import { NonNullableDate } from "../../../../../../../../utils/date-time-utility";
import { replaceUnderScoreAddSpace } from "../../../../../../../../utils/utils";

interface PreviewScreenerProps {
  dataListObj?: any;
  onEdit: (it: any) => void;
  //   onDelete: (id: any) => void;
}

const PreviewScreener = ({
  dataListObj,
  onEdit,
}: //   onDelete,

PreviewScreenerProps) => {
  return (
    !!Object.keys(dataListObj ?? {})?.length &&
    Object.keys(dataListObj ?? {})?.map((it) => {
      return (
        <Box
          onClick={() => onEdit(it)}
          sx={{
            cursor: "pointer",
            // backgroundColor: "#F7FCFF",
            borderRadius: "4px",
            color: "gray",
            padding: "6px",
            border: "1px solid #1A1A1A40",
            // boxShadow: "0px 0px 6px rgba(0, 0, 0, 0.2)",
            height: "30px",
          }}
        >
          <Flex
            justifyContent={"space-between"}
            height={"100%"}
            alignItems={"center"}
          >
            <Text>
              {`${it} - Score - ${
                dataListObj?.[it]?.score
              } - ${replaceUnderScoreAddSpace(
                dataListObj?.[it]?.severity?.toLowerCase()
              )}
               (${NonNullableDate(dataListObj?.[it]?.createdAt)})`}
            </Text>
            {/* <CloseIcon
          fontSize="small"
          sx={{
            cursor: "pointer",
          }}
          color="error"
          onClick={(e) => {
            e.stopPropagation();
            onDelete(it?.uuid);
          }}
        /> */}
          </Flex>
        </Box>
      );
    })
  );
};

export default PreviewScreener;
